import { render } from "./HeroSection.vue?vue&type=template&id=6a8c9a56"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=6a8c9a56&lang=scss"

import exportComponent from "/var/www/music-social-network/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__